var _linearGradient, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShelfNewreleases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    x1: 0.5,
    x2: 0.5,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7a397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd7aa"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.078 12.078 21.16 9.794l.268-3.027a1.077 1.077 0 0 0-.794-1.153l-2.846-.679L16.3 2.318a1.006 1.006 0 0 0-1.289-.442l-2.678 1.218L9.662 1.9a1 1 0 0 0-1.289.442l-1.5 2.607-2.836.668a1.068 1.068 0 0 0-.8 1.153l.268 3.016-1.917 2.292a1.118 1.118 0 0 0 0 1.422l1.918 2.284-.268 3.038a1.077 1.077 0 0 0 .794 1.153l2.846.679 1.485 2.607a1.015 1.015 0 0 0 1.3.442l2.671-1.217L15 23.679a1 1 0 0 0 1.289-.442l1.485-2.618 2.846-.679a1.067 1.067 0 0 0 .794-1.153l-.268-3.027 1.918-2.284a1.075 1.075 0 0 0 .01-1.4zm-9.714 6.1H11.3V16.02h2.062zm-1.031-4.309a1.058 1.058 0 0 1-1.033-1.081V8.48a1.032 1.032 0 1 1 2.062 0v4.309a1.058 1.058 0 0 1-1.029 1.077z",
    fill: "url(#a)",
    transform: "translate(-.333 -.789)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShelfNewreleases);
export default __webpack_public_path__ + "static/media/icon-shelf-newreleases.e65b647b6a2d7ecd6cc227f513f122dd.svg";
export { ForwardRef as ReactComponent };